import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { number, bool, object } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";

import { getSponsorObj } from "../../helper/api";
import { staticTexts } from "../../utils/Translate";

import "./sponsorDetails.m.css";

const SponsorDetails = ({ sponsorId, publisherAttributes, showImage = true }) => {
  const [sponsors, setSponsors] = useState([]);
  const [sponsorsLogo, setSponsorsLogo] = useState([]);
  const fetchSponsorObjects = async () => {
    const sponsorObj = await getSponsorObj(sponsorId);
    const sponsorPhoto = get(sponsorObj, ["photo", "0", "url"], null);
    setSponsors(sponsorObj);
    setSponsorsLogo(sponsorPhoto);
  };
  useEffect(() => {
    fetchSponsorObjects();
  }, [sponsorId]);
  return (
    <div styleName="base">
      {sponsors.url ? (
        <Link href={sponsors.url} target="_blank" rel="noindex nofollow">
          <div styleName="sponsor-details">
            {showImage && (
              <div styleName="sponsor-logo">{sponsorsLogo && <img src={sponsorsLogo} alt={sponsors.title} />}</div>
            )}
            <div styleName={`${!showImage ? "no-image" : ""}`}>
              <div styleName="sponsor-name">{sponsors.title}</div>
              <div styleName="sponsor-type">{staticTexts(publisherAttributes.lang).sponsorType}</div>
            </div>
          </div>
        </Link>
      ) : (
        <div styleName="sponsor-details">
          {showImage && (
            <div styleName="sponsor-logo">{sponsorsLogo && <img src={sponsorsLogo} alt={sponsors.title} />}</div>
          )}
          <div styleName={`${!showImage ? "no-image" : ""}`}>
            <div styleName="sponsor-name">{sponsors.title}</div>
            <div styleName="sponsor-type">{staticTexts(publisherAttributes.lang).sponsorType}</div>
          </div>
        </div>
      )}
    </div>
  );
};

SponsorDetails.propTypes = {
  sponsorId: number,
  publisherAttributes: object,
  showImage: bool,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(SponsorDetails);
